import React, { useMemo, useState } from 'react'

import { IconButton, Menu, TextField, Button, Theme } from '@material-ui/core'
import { ezScheduleDetails, Schedule, Service } from '../../../models'
import { Container } from '../../../components'
import { formatTotals } from '../services'
import { LineItemTotals } from '../../../containers/Scheduler_v2/Modals/BudgetModal/BudgetModal'
import AddIcon from '@material-ui/icons/Add'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import {
    HeaderValue,
    IconValue,
    TextValue,
    TotalsMoneyValue,
    TotalsTextValue,
} from '../styles'
import { LineItemRow } from './LineItemRow'
import { toast } from 'react-toastify'
import {
    AddLineItemParams,
    DeleteLineItemParams,
} from '../../../hooks/useEzSchedule/types'
import { typographyStyle } from '../../../theme/typographyStyle'

interface Props {
    totals: LineItemTotals | undefined
    scheduleDetail: Schedule | undefined
    ezSchedule: ezScheduleDetails
    theme: Theme
    addLineItem: (params: AddLineItemParams) => void
    deleteLineItem: (params: DeleteLineItemParams) => void
}

export const LineItemTable = (props: Props) => {
    const {
        theme,
        ezSchedule,
        totals,
        scheduleDetail,
        addLineItem,
        deleteLineItem,
    } = props

    const [description, setDescription] = useState('')
    const [cost, setCost] = useState(0)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const handleLineItemSave = () => {
        if (
            description.trim() === '' ||
            cost <= 0 ||
            scheduleDetail === undefined
        ) {
            toast.error(
                'Description cannot be blank and cost must be a value greater than 0',
            )
            return
        }

        addLineItem({
            scheduleId: scheduleDetail.id,
            description,
            cost,
        })
    }

    const totalCost = useMemo(() => {
        return (
            ezSchedule.line_items.reduce((sum, item) => sum + item.cost, 0) || 0
        )
    }, [ezSchedule.line_items])

    return (
        <Box sx={{ flexGrow: 1, padding: 2 }}>
            <Container
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flex: 1,
                    minHeight: 40,
                }}
            >
                {/* Title */}
                <span
                    style={{
                        ...typographyStyle(theme.typography.h6),
                        fontWeight: 700,
                        justifyContent: 'center',
                        alignItems: 'center',
                        flex: 1,
                        display: 'flex',
                    }}
                >
                    Line Items
                </span>
            </Container>
            <Grid container spacing={0}>
                {/* Header Row */}
                <Grid item xs={0.5}>
                    <HeaderValue>&nbsp;</HeaderValue>
                </Grid>
                <Grid item xs={9.5}>
                    <HeaderValue
                        style={{
                            justifyContent: 'flex-start',
                        }}
                    >
                        Line Item
                    </HeaderValue>
                </Grid>
                <Grid item xs={2}>
                    <HeaderValue
                        style={{
                            justifyContent: 'flex-end',
                        }}
                    >
                        Cost
                    </HeaderValue>
                </Grid>

                {/* data rows */}
                {ezSchedule.line_items.map((li) => (
                    <LineItemRow
                        {...props}
                        key={`LINE-ITEM-${li.id}`}
                        lineItem={li}
                    ></LineItemRow>
                ))}

                {/* Add Line Item Row */}
                <Grid item xs={0.5}>
                    <IconValue
                        style={{
                            justifyContent: 'center',
                        }}
                    >
                        <IconButton onClick={openMenu}>
                            <AddIcon />
                        </IconButton>
                    </IconValue>
                </Grid>
                <Grid item xs={9.5}>
                    <TextValue></TextValue>
                </Grid>
                <Grid item xs={2}>
                    <TextValue></TextValue>
                </Grid>

                {/* Totals Row */}
                <Grid item xs={0.5}>
                    <TotalsTextValue>&nbsp;</TotalsTextValue>
                </Grid>
                <Grid item xs={9.5}>
                    <TotalsTextValue>Totals</TotalsTextValue>
                </Grid>
                <Grid item xs={2}>
                    <TotalsMoneyValue>
                        {formatTotals(totalCost)}
                    </TotalsMoneyValue>
                </Grid>
            </Grid>
            <Menu
                style={
                    {
                        // height: '70%',
                        // width: '50%',
                    }
                }
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <Container>
                    <TextField
                        style={{ margin: theme.spacing(1) }}
                        label="Line Item"
                        placeholder="Enter Description"
                        value={description}
                        inputProps={{ maxLength: 50 }}
                        onChange={(e) => setDescription(e.target.value)}
                        fullWidth
                    />
                    <TextField
                        style={{ margin: theme.spacing(1) }}
                        label="Cost"
                        placeholder="Enter Value"
                        type="number"
                        inputProps={{ maxLength: 50 }}
                        onChange={(e) => setCost(Number(e.target.value))}
                        prefix="$"
                        fullWidth
                    />
                    <Button
                        variant="contained"
                        style={{
                            ...typographyStyle(theme.typography.subtitle1),
                            marginLeft: theme.spacing(2),
                            marginTop: theme.spacing(3),
                            marginRight: theme.spacing(1),
                            backgroundColor: theme.palette.primary.dark,
                            color: 'white',
                            textTransform: 'none',
                            cursor: 'pointer',
                            height: 30,
                            width: 40,
                        }}
                        onClick={() => handleLineItemSave()}
                    >
                        Save
                    </Button>
                </Container>
            </Menu>
        </Box>
    )
}
